export default __webpack_public_path__ + "f5b74d7ffcdf85b9dd60130fa0b2c087.woff2";